/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A notification action which executes an Activiti job when triggered
 */
export interface JobAction { 
    /**
     * The namespace
     */
    namespace: string;
    /**
     * The job name
     */
    jobName: string;
    /**
     * The correlation data
     */
    correlationData?: string;
}
